import React, { useEffect, useRef, useState } from "react";
import GoogleMapReact from "google-map-react";
import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";

const MapEventModal = ({
  modalOpen,
  setModalOpen,
  eventDetail,
  bookingDetail,
  loading,
  apiCall = () => {},
}) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  const [coordinates, setCoordinates] = useState({
    lat: 52.367925,
    lng: 4.846423,
  });

  const [mapInstance, setMapInstance] = useState(null);
  const [mapsInstance, setMapsInstance] = useState(null);
  const markerRef = useRef(null);

  const zoom = 11;

  const handleApiLoaded = ({ map, maps }) => {
    setMapInstance(map);
    setMapsInstance(maps);

    markerRef.current = new maps.Marker({
      position: coordinates,
      map,
      draggable: true, // ✅ Enable dragging
      icon: {
        url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        scaledSize: new maps.Size(40, 40),
      },
    });

    // When drag ends → update state
    markerRef.current.addListener("dragend", (event) => {
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();

      setCoordinates({
        lat: newLat,
        lng: newLng,
      });
    });
  };

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setPosition(coordinates);
    }

    if (mapInstance) {
      mapInstance.panTo(coordinates);
    }
  }, [coordinates]);

  // Map click
  const handleMapClick = ({ lat, lng }) => {
    setCoordinates({ lat, lng });
  };

  // Manual input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setCoordinates((prev) => ({
      ...prev,
      [name]: parseFloat(value),
    }));
  };

  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      className={"map-event-modal"}
      title={
        <>{`${eventDetail?.split("_").join(" ")} trigger from system manually`}</>
      }
    >
      <div className="pt-8 ml-21 mr-24">
        {/* Lat / Lng Fields */}
        <div className="flex gap-16 mb-16 align-item-end">
          <div className="airport-service-level-fields">
            <label>Latitude</label>
            <input
              type="number"
              name="lat"
              value={coordinates.lat}
              onChange={handleInputChange}
              className="h-40"
            />
          </div>

          <div className="airport-service-level-fields">
            <label>Longitude</label>
            <input
              type="number"
              name="lng"
              value={coordinates.lng}
              onChange={handleInputChange}
              className="h-40"
            />
          </div>
          <div>
            <MOButtonV2
              type="submit"
              disabled={loading}
              text={"SUBMIT"}
              textColor="#ffffff"
              radius={4}
              widthSize={137}
              height={36}
              padding={"10px 12px"}
              backgroundColor="#29AEE6"
              fontSize={11}
              onClick={() => {
                apiCall(
                  eventDetail,
                  bookingDetail.id,
                  coordinates.lat,
                  coordinates.lng,
                );
              }}
            />
          </div>
        </div>

        {/* Map */}
        <div style={{ height: "400px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: apiKey }}
            center={coordinates}
            defaultZoom={zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={handleApiLoaded}
            onClick={handleMapClick}
          />
        </div>
      </div>
    </MOModalWrapper>
  );
};

export default MapEventModal;
